import React from 'react';
import PropTypes from 'prop-types';
import SrButtonDeprecated from 'client/components/SrButtonDeprecated';

function SrFeedNoResults({ isCategoryQualified, onChangeClick }) {
  const context = isCategoryQualified ? 'qualifications' : 'filters';
  const buttonText = `Change your ${context}`;
  return (
    <div className="SrFeedNoResults">
      <div className="SrFeedNoResultsTitle">
        <span>No results</span>
      </div>
      <div className="SrFeedNoResultsExplainer">
        <span>Your {context} are limiting your results.</span>
        <span>Please update them to see more rentals.</span>
      </div>
      <SrButtonDeprecated
        text={buttonText}
        onClick={onChangeClick}
        leftIconClassName="gear"
        className="yellow"
      />
    </div>
  );
}

SrFeedNoResults.propTypes = {
  isCategoryQualified: PropTypes.bool.isRequired,
  onChangeClick: PropTypes.func,
};

SrFeedNoResults.displayName = 'SrFeedNoResults';

export default SrFeedNoResults;
